var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,13.2l-3.9-1.7c-0.1,0-0.2,0-0.2,0s-0.1,0.1-0.1,0.2L11.5,21l-2.3-9.3c0-0.1-0.1-0.1-0.1-0.2 c-0.1,0-0.1,0-0.2,0L4.9,13c-0.5,0.2-0.8,0.6-0.8,1.1v8c0,0.1,0.1,0.3,0.3,0.3h14.3c0.1,0,0.3-0.1,0.3-0.3v-7.9 C19,13.9,18.7,13.4,18.2,13.2L18.2,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,12.3c0.2-0.3,0.1-0.7-0.1-0.9c-0.1-0.2-0.4-0.2-0.6-0.2H11c-0.2,0-0.5,0.1-0.6,0.2 c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.1,0.2,0.2,0.5,0.2,0.8l-0.2,1.8l0.5,1.5c0.1,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3 l0.5-1.5l-0.2-1.8c0-0.3,0-0.6,0.2-0.8L12.8,12.3z M11.5,10.4c2.3,0,4.2-1.9,4.2-4.2V4.8c0-2.3-1.9-4.2-4.2-4.2S7.3,2.4,7.3,4.8 v1.3C7.3,8.5,9.2,10.4,11.5,10.4L11.5,10.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/employee_icon.de8c435d1c618df6495643313a1cacb4.svg";
export { ForwardRef as ReactComponent };